export default __webpack_public_path__ + "static/media/ic-payment-request.1931bd08.svg";